<template>
  <div>
    <va-card title="Empresas">
      <form ref="form" @submit.prevent>
        <div class="row">
          <div class="flex md4 sm6 xs12">
            <va-input v-model="company.name" label="Nome" placeholder="Nome" />
          </div>
          <div class="flex md4 sm6 xs12">
            <va-input v-model="company.tenant_name" label="Tenant" placeholder="Nome do Tenant"
              v-if="this.edit == true" />
          </div>

          <div class="flex md4 sm6 xs12">
            <va-select
              label="Idioma"
              textBy="language"
              keyBy="prefix"
              v-model="company.locale"
              :options="locales"
              placeholder="Selecione o idioma"
              v-if="this.edit == true"
            />
          </div>
        </div>
        <div class="row">
          <div class="flex xs4 md2">
            <div class="vuestic-color-picker-page__top-square">
              <span
                class="title no-wrap"
              >
                Cor Primaria
              </span>
            </div>
              <va-color-picker-input
                mode="advanced"
                v-model="$themes.primary"
              >
                <va-color-square :value="$themes.primary"/>
              </va-color-picker-input>
          </div>
          <div class="flex xs4 md2">
            <div class="vuestic-color-picker-page__top-square">
              <span
                class="title no-wrap"
              >
                Cor Secundária
              </span>
              <va-color-picker-input
                mode="advanced"
                v-model="$themes.secondary" 
              >
                <va-color-square :value="$themes.secondary"/>
              </va-color-picker-input>
            </div>
          </div>
        </div>
        <div class="row">
          <va-button
            medium
            inline
            color="secondary"
            icon="fa fa-save"
            class="ma-0"
            @click="save()"
            v-if="this.edit == true"
          >Salvar</va-button>
        </div>
        <div class="row">
          <va-button
            medium
            inline
            color="secondary"
            icon="fa fa-save"
            class="ma-0"
            @click="updateCompany(company)"
            v-if="this.update == false"
          >Atualizar</va-button>
        </div>
      </form>
    </va-card>
    <div v-show="loading" class="text--center pb-4">
      <div class="flex-center spinner-box">
        <slot name="loading">
          <spring-spinner
            slot="loading"
            :animation-duration="currentDuration"
            :is="spload.name"
            :color="spinnersColor"
            :size="config.size"
          />
        </slot>
      </div>
    </div>

    <va-button
        medium
        inline
        color="secondary"
        icon="fa fa-refresh"
        class="ma-0"
        @click="syncPermissions()"
      >Sincronizar Permissões
      </va-button>
      <va-separator/>

    <va-data-table
      :fields="fields"
      :data="companies"
      :per-page="10"
      no-data-label="Nothing to display, sir!"
    >

    <template slot="color_secondary" slot-scope="props">
      <va-badge class="ma-0" v-if="props.rowData.color_secondary != undefined" :color="props.rowData.color_secondary">
        {{props.rowData.color_secondary}}
      </va-badge>
    </template>
  
    <template slot="color_primary" v-if="props.rowData.color_secondary != undefined" slot-scope="props">
        <va-badge class="ma-0" :color="props.rowData.color_primary">
          {{props.rowData.color_primary}}
        </va-badge>
    </template>

    <template slot="actions" slot-scope="props">
      <va-button
          small
          inline
          color="green"
          icon="fa fa-edit"
          class="mr-1"
          @click="editCompany(props.rowData.id)" 
        >
          {{ $t('menu.edit') }}
      </va-button>
    </template>
  
    </va-data-table>

  </div>
</template>

<script>
import { http } from "@/services/config"
import * as spinners from "epic-spinners"
import { showError } from '@/global'

export default {
  components: {
    ...spinners
  },
  name: "Companies",
  data() {
    return {
      loading: false,
      edit: true,
      update: true,
      company: {
        companyId: "",
        name: "",
        tenant_name: "",
        locale: "",
        color_primary: '',
        color_secondary: ''
      },
      locales: [
        { language: "Português Brasil", prefix: "pt-BR" },
        { language: "Inglês", prefix: "en" },
      ],
      config: {
        size: 80,
        group: 4,
        duration: 1500
      },
      spinnersColor: this.$themes.secondary,
      currentDuration: 1500,
      companies: [],
    };
  },
  mounted() {
    this.getCompanies();
  },

  computed: {
    fields () {
      return [
        { name: "name", title: "Nome" },
        { name: "tenant_name", title: "Tenant" },
        { name: "locale", title: "Idioma" },
        { name: '__slot:color_primary', title: "Cor Primária", width: '10%' },
        { name: "__slot:color_secondary", title: "Cor Secundária", width: '10%' },
        { name: "__slot:actions", width: '10%' }
      ]
    },
    spload() {
      return spinners.ScalingSquaresSpinner
    }
  },

  methods: {
    getCompanies() {
      http.get("companies").then(res => {
        this.companies = res.data["companies"]
      });
    },

    reset() {
      (this.company.name = ""), (this.company.tenant_name = ""),
      (this.$themes.primary = "#FFFFFF"), (this.$themes.secondary = "#000000"),
      (this.edit = true), (this.update = true)
    },

    save() {
      this.loading = true;
      http.post("companies", {
        company: {
          name: this.company.name,
          tenant_name: this.company.tenant_name,
          locale: this.company.locale.prefix,
          color_primary: this.$themes.primary,
          color_secondary: this.$themes.secondary
        }
      }).then(response => {
        this.showToast(response.data.message, {
          icon: 'fa-thumbs-o-up',
          position: 'top-right',
          duration: 5000,
        })
        this.loading = false
        this.reset()
        this.getCompanies()
      }).catch(e => {
          this.showToast(e.response.data.error, {
            icon: 'fa-thumbs-o-down',
            position: 'top-right',
            duration: 5000,
          })
          this.loading = false
      });
    },

    updateCompany(company) {
      this.loading = true;
      http.put("companies/" + company.companyId, {
          name: company.name,
          color_primary: this.$themes.primary,
          color_secondary: this.$themes.secondary
      }).then(response => {
        this.showToast(response.data.message, {
          icon: 'fa-thumbs-o-up',
          position: 'top-right',
          duration: 5000,
        })
        this.loading = false
        this.reset()
        this.getCompanies()
      }).catch(e => {
          this.showToast(e.response.data.error, {
            icon: 'fa-thumbs-o-down',
            position: 'top-right',
            duration: 5000,
          })
          this.loading = false
      });
    },

    editCompany(companyId) {
      http.get("companies/" + companyId).then(response => {
        this.company.companyId = response.data.company.id
        this.company.name = response.data.company.name
        this.$themes.primary = (response.data.company.color_primary != null) ? response.data.company.color_primary : "#FFFFFF"
        this.$themes.secondary = (response.data.company.color_secondary != null) ? response.data.company.color_secondary : "#000000"

        this.edit = false
        this.update = false
      })
    },

    async syncPermissions(){
      this.loading = true
      await http.post("companies/sync_permissions/").then(response =>{
        this.loading = false
        this.showToast(response.data.message, {
          icon: 'fa-thumbs-o-up',
          position: 'top-right',
          duration: 5000,
        })
      }).catch(e => {
          this.showToast(e.response.data.error, {
            icon: 'fa-thumbs-o-down',
            position: 'top-right',
            duration: 5000,
          })
      });
    }
  }
};
</script>

<style scoped>
.va-card {
  margin-bottom: 20px;
}
</style>
